import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from './api';
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TaxonomyService {
    unauthPath: string = '/ws/ua/taxonomy';
    path: string = '/ws/taxonomy';

    constructor(private api: ApiService){}

    getTenantTaxonomy = (filterEmpty: boolean, published: boolean, includeSubcategories: boolean):Observable<any> =>
        this.api.get(this.unauthPath + '/', new HttpParams()
            .set('filterEmpty', String(filterEmpty))
            .set('published', String(published))
            .set('includeSubcategories', String(includeSubcategories))).pipe(tap(res => res.user));

    getTenantTaxonomyDetails = (filterEmpty: boolean, published: boolean, includeSubcategories: boolean):Observable<any> =>
        this.api.get(this.unauthPath + '/details', new HttpParams()
            .set('filterEmpty', String(filterEmpty))
            .set('published', String(published))
            .set('includeSubcategories', String(includeSubcategories))).pipe(tap(res => res.user));

    getCatalogTaxonomy(catalogId: string, params: {filterEmpty: boolean}): Observable<any> {
        return this.api.get(`${this.unauthPath}/catalog/${catalogId}/taxonomy`, this.api.paramify(params));
    }

    getTenantlessCatalogTaxonomy(catalogId: string, params: {filterEmpty: boolean}): Observable<any> {
        return this.api.get(`${this.path}/catalog/${catalogId}/taxonomy/tenantless`, this.api.paramify(params));
    }

    putTenantTaxonomy(taxonomy, taxonomyVersion) {
        return this.api.put('/ws/taxonomy/' + taxonomyVersion, taxonomy);
    }

    putCatalogTaxonomy(catalogId, taxonomy) {
        return this.api.put(`/ws/taxonomy/catalog/${catalogId}/taxonomy`, taxonomy);
    };
};
